import React, { FC, useEffect, useState } from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/styles';
import ledStores from 'stores/led';
import { observer } from 'mobx-react-lite';

const useStyles = makeStyles(() => ({
  root: {
    position: 'relative',
    color: 'white',
    backgroundColor: '#DB4957',
    fontSize: 16,
    fontWeight: 600,
    boxShadow: '0 10px 20px 0 rgba(0, 0, 0, 0.1)',
    width: 350,
    padding: '20px 30px',
    '& .MuiIconButton-sizeSmall': {
      marginTop: -33,
      marginRight: -15,
      color: '#fff',
      boxShadow: 'none',
      fontSize: 22,
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
  },
  time: {
    position: 'absolute',
    left: 0,
    bottom: 0,
    height: 5,
    backgroundColor: '#f3c3c9',
    borderBottomLeftRadius: 3,
  },
}));

const Alert = (props: AlertProps) => <MuiAlert elevation={6} variant="filled" {...props} />;

const intervalStep = 100;
const duration = 3000;

const LedServerError: FC = observer(() => {
  const classes = useStyles();
  const { ledLayoutStore } = ledStores;
  const { closeServerError, errorMessage, isServerErrorOpen } = ledLayoutStore;
  const [timeWidth, setTimeWidth] = useState<number>(0);

  useEffect(() => {
    let passed = 0;
    const interval = setInterval(() => {
      const newWidth = Math.floor((100 * passed) / duration);
      if (newWidth !== timeWidth) {
        setTimeWidth(newWidth);
      }
      passed += intervalStep;
      if (passed >= duration) {
        clearInterval(interval);
        closeServerError();
      }
    }, intervalStep);
  }, [isServerErrorOpen]);

  return (
    <div>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={isServerErrorOpen}
        onClose={closeServerError}
      >
        <>
          <Alert severity="error" onClose={closeServerError} className={classes.root} icon={false}>
            {errorMessage}
            <div className={classes.time} style={{ width: `${timeWidth}%` }} />
          </Alert>
        </>
      </Snackbar>
    </div>
  );
});

export default LedServerError;
